import { EventEmitter, Output } from '@angular/core';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tabs, [tabs]',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit {
  @Input() data: Array<Tab> = [];
  @Input() withWrapper = true;
  @Input() isSubNav = false;
  @Input() title = '';
  @Input() tabSubNavClasses = '';
  @Input() tabNavClasses = 'tabs-module tabs-module--expanded tabs-module--revised';
  @Output() getSelectedTab = new EventEmitter<number | string>();

  constructor() {}

  ngOnInit(): void {}

  /**
   * Change active tab
   * @param selectedTab     Selected tab id
   */
  onTabChange(selectedTab: number | string) {
    this.data.forEach((tab) => {
      tab.isActive = tab.id === selectedTab;

      if (tab.isActive) this.getSelectedTab.emit(tab.id);
    });
  }

  /**
   * Check if only one tab to show
   */
  checkIsSingleTab() {
    if(this.tabSubNavClasses){
      return this.tabSubNavClasses
    }
    return this.data.filter((d) => d.show).length > 1;
  }
}

interface Tab {
  id: number | string;
  name: string;
  isActive: boolean;
  icon?: string;
  enabled: boolean;
  show?: boolean;
}
